import { GlobalCXContextValue } from '~/components/ClientExperience/providers/global-context/global-cx.context';
import { BaseStore } from '~/stores/base.store';
import { ClientPortalConfigStore } from './client-portal-config.store';
import { InjectorService } from '~/services/injector.service';

import { CXApiService } from '../services/cx-api.service';
import { CXNoAuthApiService } from '../services/cx-no-auth-api.service';

import { ConfigCXCtrl } from '../controllers/config-cx.ctrl';

/* ********************* Gift Card ********************** */
import { GiftCardCXStore } from '../GiftCard/stores/gift-card-cx.store';

import { S3ApiAdapter } from '../services/adapters/s3-api.adapter';
import { GiftCardCXApiService } from '../GiftCard/services/gift-card-cx-api.service';

import { InstantPayController } from '../GiftCard/controllers/instant-pay.controller';
import { InstantPayStore } from '../GiftCard/stores/instant-pay.store';
import { GiftCardCXController } from '../GiftCard/controllers/gift-card-cx.controller';

/* ********************* One Flow ********************** */
import { CompanyStore } from '~/stores/company.store';
import { FlowViewUiStore } from '../OneFlow/stores/flow-view.ui.store';
import { CxFlowStore } from '../OneFlow/stores/cx-flow.store';
import { CXUserStore } from '../OneFlow/stores/cx-user.store';

import { FlowCXService } from '../OneFlow/services/flow-cx.service';
import { LeadFormCxService } from '../OneFlow/services/lead-form-cx.service';
// import { OneFlowCxApiService } from '../OneFlow/services/one-flow-cx-api.service';
import { FlowContextVariablesStore } from '../OneFlow/stores/flow-context-variables.store';
import { CXFlowSessionStore } from '../OneFlow/stores/cx-flow-session.store';
import { FlowCXController } from '../OneFlow/controllers/flow-cx.controller';
import { LeadFormCxController } from '../OneFlow/controllers/lead-form-cx.controller';
import { SessionCXCtrl } from '../OneFlow/controllers/session-cx.controller';
import { PayController } from '../OneFlow/controllers/pay.controller';
import { CXSessionService } from '../OneFlow/services/cx-session.service';
import { UserCXCtrl } from '../controllers/user-cx.ctrl';
import { FlowComponentsCXCtrl } from '~/components/ClientExperience/OneFlow/controllers/flow-components-cx.ctrl';
import { PrintController } from '~/components/ClientExperience/OneFlow/controllers/print.controller';
import { CXScheduleController } from '~/components/ClientExperience/OneFlow/controllers/cx-schedule.controller';
import { CXScheduleService } from '~/components/ClientExperience/OneFlow/services/cx-schedule.service';
import { CXScheduleAvailabilitiesStore } from '~/components/ClientExperience/OneFlow/stores/cx-schedule-availabilities.store';
import { isPublicFlowRoute } from '~/utils/public-flows.utils';
import { PublicCXApiService } from '~/components/ClientExperience/services/public-cx-api.service';
import { PublicCXScheduleController } from '~/components/ClientExperience/OneFlow/controllers/public-cx-schedule.controller';
import { PublicPendingTaskService } from '~/components/ClientExperience/OneFlow/services/public-pending-task.service';
import { PublicPendingTaskController } from '~/components/ClientExperience/OneFlow/controllers/public-pending-task.controller';
import { CompanyCXService } from '~/components/ClientExperience/services/company-cx.service';
import { ConfigCXService } from '~/components/ClientExperience/services/config-cx.service';
import { UserCXService } from '~/components/ClientExperience/services/user-cx.service';
import { CXSessionStore } from '~/components/ClientExperience/OneFlow/stores/cx-session-store';
import { CXFlowSessionService } from '~/components/ClientExperience/OneFlow/services/cx-flow-session.service';
import { ImageService } from '~/services/image.service';
import { FlowSessionCXCtrl } from '~/components/ClientExperience/OneFlow/controllers/flow-session-cx.controller';
import { getGlobalCXContext } from '~/components/ClientExperience/providers/global-context/global-cx-context.factory';
import { CXCompanyConfigurationService } from '~/services/cx-services/cx-company-configuration.service';
import { ILocalStorage } from '~/services/interfaces/ILocalStorage';
import { PayStore } from '~/components/ClientExperience/OneFlow/stores/pay.store';
import { PublicFlowCxService } from '~/components/ClientExperience/OneFlow/services/public-flow-cx.service';
import { isPublicTemplateViewMode } from '~/utils/public-template-view-mode-flow.utils';
import { ClientPendingTaskService } from '~/services/client-pending-task.service';
import { ClientPendingTaskController } from '~/controllers/client-pending-task.controller';

export class CXRootStore extends BaseStore {
    // We must hold instance of the global context so we can run test in parallel, the base store would be split overtime and won't be needed
    globalContext: GlobalCXContextValue;

    noAuthApiService: CXNoAuthApiService = null;
    publicCxApiService: PublicCXApiService = null;
    userService: UserCXService = null;
    flowSessionStore: CXFlowSessionStore = null; // TODO: This need to move into cx-flow.context
    /**
     * @deprecated Please use the one which is provided from the globalContext instead, this will be removed as part of the root store separation
     */
    get clientPortalConfigStore(): ClientPortalConfigStore {
        return this.globalContext.clientPortalConfigStore;
    }
    /**
     * @deprecated Please use the one which is provided from the globalContext instead (apiService), this will be removed as part of the root store separation
     */
    get cxApiService(): CXApiService {
        return this.globalContext.apiService as CXApiService;
    }
    get sessionStore(): CXSessionStore {
        return this.globalContext.sessionStore;
    }

    get clientPendingTaskService(): ClientPendingTaskService {
        return this.globalContext.clientPendingTaskService;
    }

    get clientPendingTaskCtrl(): ClientPendingTaskController {
        return this.globalContext.clientPendingTaskCtrl;
    }

    public get injectorService(): InjectorService {
        return this.globalContext.injectorService;
    }

    configCtrl: ConfigCXCtrl = null;
    flowComponentsCtrl: FlowComponentsCXCtrl = null;
    imageService: ImageService = null;

    // #region gift card

    giftCardCXStore: GiftCardCXStore = null;
    instantPayStore: InstantPayStore = null;

    s3ApiAdapter: S3ApiAdapter = null;
    giftCardCXApiService: GiftCardCXApiService = null;

    giftCardCXCtrl: GiftCardCXController = null;
    instantPayCtrl: InstantPayController = null;

    // #endregion

    // #region one flow
    companyService: CompanyCXService = null;
    configService: ConfigCXService = null;

    flowViewUiStore: FlowViewUiStore = null;
    payStore: PayStore = null;
    flowStore: CxFlowStore = null;
    scheduleAvailabilitiesStore: CXScheduleAvailabilitiesStore = null;
    flowSessionService: CXFlowSessionService = null; // TODO: This need to move into cx-flow.context
    publicPendingTaskService: PublicPendingTaskService = null;
    scheduleService: CXScheduleService = null;
    get userStore(): CXUserStore {
        return this.globalContext.userStore;
    }
    get companyStore(): CompanyStore {
        return this.globalContext.companyStore;
    }
    get sessionService(): CXSessionService {
        return this.globalContext.sessionService;
    }

    /**
     * @deprecated Please use the one which is provided from the cx globalContext instead, this will be removed as part of the root store separation
     */
    get storageService(): ILocalStorage {
        return this.globalContext.storageService;
    }

    flowSessionCXCtrl: FlowSessionCXCtrl = null;
    leadFormPendingTaskCtrl: PublicPendingTaskController = null;
    flowCXCtrl: FlowCXController = null;
    leadFormCtrl: LeadFormCxController = null;
    flowContextVariablesStore: FlowContextVariablesStore = null;
    payCtrl: PayController = null;
    userCtrl: UserCXCtrl = null;
    printCtrl: PrintController = null;
    scheduleCXCtrl: CXScheduleController = null;
    publicScheduleCtrl: PublicCXScheduleController = null;
    leadFormService: LeadFormCxService = null;
    publicFlowService: PublicFlowCxService = null;
    flowCXService: FlowCXService = null;
    get sessionCtrl(): SessionCXCtrl {
        return this.globalContext.sessionCtrl;
    }
    get webSocketsAdapter() {
        return this.globalContext.webSocketsAdapter;
    }

    get webSocketsService() {
        return this.globalContext.webSocketsService;
    }

    // #endregion

    constructor(globalContext: GlobalCXContextValue = null) {
        const globalCXContextValue = globalContext || getGlobalCXContext();
        super(globalCXContextValue);
        this.globalContext = globalCXContextValue;

        this.s3ApiAdapter = new S3ApiAdapter(this.globalContext);
        this.noAuthApiService = new CXNoAuthApiService(this.globalContext);

        this.payStore = new PayStore(this);
        this.flowViewUiStore = new FlowViewUiStore(this);
        this.configCtrl = new ConfigCXCtrl(this);
        this.flowComponentsCtrl = new FlowComponentsCXCtrl(this);

        this.companyService = new CompanyCXService(this);
        this.configService = new ConfigCXService({
            clientPortalConfigStore: this.clientPortalConfigStore,
            noAuthApiService: this.noAuthApiService,
            cxCompanyConfigurationService: new CXCompanyConfigurationService(
                this.s3ApiAdapter
            ),
            s3ApiAdapter: this.s3ApiAdapter
        });
        this.publicCxApiService = new PublicCXApiService(
            this as PublicCXRootStore
        );
        this.userService = new UserCXService({
            apiService: this.cxApiService,
            noAuthApiService: this.noAuthApiService,
            s3ApiAdapter: this.s3ApiAdapter,
            clientPortalConfigStore: this.clientPortalConfigStore
        });

        this.publicPendingTaskService = new PublicPendingTaskService(this);
        this.leadFormPendingTaskCtrl = new PublicPendingTaskController(this);
        this.imageService = new ImageService(this.cxApiService);

        // #region gift card
        this.giftCardCXStore = new GiftCardCXStore(this);
        this.instantPayStore = new InstantPayStore(this);

        this.giftCardCXApiService = new GiftCardCXApiService(
            this.globalContext
        );

        this.giftCardCXCtrl = new GiftCardCXController(this);
        this.instantPayCtrl = new InstantPayController(this);

        // #endregion

        // #region one flow
        this.flowStore = new CxFlowStore(this);
        this.flowSessionStore = new CXFlowSessionStore(this);
        this.sessionStore.setFlowSessionStore(this.flowSessionStore);
        this.userStore.setFlowSessionStore(this.flowSessionStore);
        this.scheduleAvailabilitiesStore = new CXScheduleAvailabilitiesStore(
            this
        );

        this.flowCXService = new FlowCXService({
            cxNoAuthApiService: this.noAuthApiService,
            apiAdapter: this.cxApiService,
            clientPortalConfigStore: this.clientPortalConfigStore,
            s3ApiAdapter: this.s3ApiAdapter
        });
        this.leadFormService = new LeadFormCxService({
            cxNoAuthApiService: this.noAuthApiService,
            apiAdapter: this.cxApiService,
            clientPortalConfigStore: this.clientPortalConfigStore,
            s3ApiAdapter: this.s3ApiAdapter
        });
        this.publicFlowService = new PublicFlowCxService({
            cxNoAuthApiService: this.noAuthApiService,
            apiAdapter: this.cxApiService,
            clientPortalConfigStore: this.clientPortalConfigStore,
            s3ApiAdapter: this.s3ApiAdapter
        });

        this.flowSessionService = new CXFlowSessionService(this);

        // this.unauthenticatedApiService = new OneFlowCxApiService(this);
        this.scheduleService = new CXScheduleService(this);
        this.flowSessionCXCtrl = new FlowSessionCXCtrl(this);
        this.flowCXCtrl = new FlowCXController(this);
        this.leadFormCtrl = new LeadFormCxController(this as PublicCXRootStore);
        this.flowContextVariablesStore = new FlowContextVariablesStore(this);
        this.payCtrl = new PayController(this);
        this.userCtrl = new UserCXCtrl(this);
        this.printCtrl = new PrintController(this);
        this.scheduleCXCtrl = new CXScheduleController(this);
        this.publicScheduleCtrl = new PublicCXScheduleController(this);
        // #endregion
    }

    public get scheduleCtrl():
        | CXScheduleController
        | PublicCXScheduleController {
        if (isPublicFlowRoute()) {
            return this.publicScheduleCtrl;
        }
        return this.scheduleCXCtrl;
    }

    public get flowService():
        | FlowCXService
        | LeadFormCxService
        | PublicFlowCxService {
        if (isPublicFlowRoute()) {
            return this.leadFormService;
        }
        if (isPublicTemplateViewMode()) {
            return this.publicFlowService;
        }
        return this.flowCXService;
    }

    public get flowCtrl(): FlowCXController | LeadFormCxController {
        if (isPublicFlowRoute()) {
            return this.leadFormCtrl;
        }
        return this.flowCXCtrl;
    }

    public get apiService(): CXApiService | PublicCXApiService {
        if (isPublicFlowRoute()) {
            return this.publicCxApiService;
        }
        return this.cxApiService;
    }
}

export interface PublicCXRootStore extends CXRootStore {
    flowCtrl: LeadFormCxController;
    flowService: PublicFlowCxService;
    get apiService(): PublicCXApiService;
}
